import React from 'react';

const Button = props => {
   const { children, theme = 'soft-red', className, ...restProps } = props;

   let buttonTheme = '';
   if (theme === 'soft-red') {
      buttonTheme = 'custom-button-soft-red ';
   } else if (theme === 'dark') {
      buttonTheme = 'custom-button-dark';
   }

   return (
      <button className={`${buttonTheme} ${className}`} {...restProps}>
         {children}
      </button>
   );
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/button.js